import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["orderedListData", "gridModifier", "omitWrappers", "bannerProps", "priorityLimit"];
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CardsRenderItem from './CardsRenderItem';
import Wrapper from '../../../Wrapper';
import { withTitle } from '../../../../HOC';
import { checkIfShouldRenderBanner } from '../helpers';
const CardsRenderWrapper = _ref => {
  let {
      orderedListData,
      gridModifier,
      omitWrappers,
      bannerProps,
      priorityLimit
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  let bannerIndex = 0;
  const WrapperToUse = omitWrappers ? Fragment : Wrapper;
  return /*#__PURE__*/React.createElement(WrapperToUse, {
    className: "grid",
    modifiers: gridModifier
  }, orderedListData.map((cardProps, index) => {
    const {
      id
    } = cardProps;
    const shouldRenderBanner = !!bannerProps && checkIfShouldRenderBanner(index, bannerProps);
    if (shouldRenderBanner) bannerIndex += 1;
    const priority = priorityLimit > 0 && index + 1 <= priorityLimit;
    return /*#__PURE__*/React.createElement(CardsRenderItem, _extends({
      key: id,
      index: index,
      cardProps: cardProps,
      gridModifier: gridModifier,
      listProps: props,
      shouldRenderBanner: shouldRenderBanner,
      bannerProps: bannerProps,
      bannerIndex: bannerIndex,
      priority: priority
    }, props));
  }));
};
CardsRenderWrapper.propTypes = {
  orderedListData: PropTypes.array.isRequired,
  gridModifier: PropTypes.string.isRequired,
  omitWrappers: PropTypes.bool,
  imagesData: PropTypes.array,
  bannerProps: PropTypes.object,
  priorityLimit: PropTypes.number
};
CardsRenderWrapper.defaultProps = {
  omitWrappers: false,
  imagesData: [],
  bannerProps: {},
  priorityLimit: 0
};
export default withTitle(CardsRenderWrapper);
//# sourceMappingURL=CardsRenderWrapper.js.map